import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Route } from 'react-router-dom';
import Loading from '../Loading';
import IgBusiness from '../../igbusiness_components/Main'
import { currentVpPermissions, currentVProles, currentFeatures } from './functions';

@injectIntl
@observer
export default class IgBusinessWrapper extends React.Component {
  state = {
    loading: true,
    permissions: {},
    userRoles: [],
    current_vp: null,
    vision_bmc: null,
    current_mvp: null,
    current_bmc: null,
  };

  componentDidMount() {
    this.fetchCurrVpPermissions();
  }

  fetchCurrVpPermissions = async () => {
    const [
      permissions,
      userRoles, {
        current_vp,
        vision_bmc,
        current_mvp,
        current_bmc,
      }] = await Promise.all([currentVpPermissions(), currentVProles(), currentFeatures()]);

    return this.setState({
      loading: false,
      permissions,
      userRoles,
      current_vp,
      vision_bmc,
      current_mvp,
      current_bmc,
    });

  };

  render() {
    const { intl, } = this.props;

    const { current_bmc, vision_bmc, loading } = this.state;

    if (loading) return <Loading></Loading>;

    return (
      <div key={'business_div'}>
        <Route render={p => <IgBusiness
          {...p}
          key={'igbusiness_main'}
          visionBoardId={vision_bmc}
          currentBoardId={current_bmc}
          currentUserPermission={this.state.permissions}
          userRoles={this.state.userRoles}
          userLocale={intl.locale}
        />} />

      </div>
    );
  }
}

IgBusinessWrapper.propTypes = {};
